import type { TFunction } from "react-i18next"
import { useState } from "react"
import { PaymentTimelineItem } from "@oysterhr/schema"
import { PayoutTimelineItemDetail } from "./PayoutTimelineItem"
import { Icon } from "@oysterhr/ui"

interface PayoutTimelineItemListProps {
  item: PaymentTimelineItem
  t: TFunction
}

export const PAYOUT_TIMELINE_EVENT_LIST_LIMIT = 4

export const PayoutTimelineItemList = ({ item, t }: PayoutTimelineItemListProps) => {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <div className="flex flex-col justify-center space-y-4">
      {item.events?.map((event, index) =>
        !isExpanded ? (
          index < PAYOUT_TIMELINE_EVENT_LIST_LIMIT && (
            <PayoutTimelineItemDetail
              event={event}
              bankAccount={item.bankAccount}
              t={t}
              index={index}
              key={index}
            />
          )
        ) : (
          <PayoutTimelineItemDetail
            event={event}
            bankAccount={item.bankAccount}
            t={t}
            index={index}
            key={index}
          />
        ),
      )}
      {item.events && item.events.length > PAYOUT_TIMELINE_EVENT_LIST_LIMIT && (
        <button
          aria-label="See all payment events"
          className="flex items-center justify-center space-x-1 pt-2"
          onClick={() => setIsExpanded(isExpanded => !isExpanded)}
        >
          <Icon name={isExpanded ? "ChevronUp" : "ChevronDown"} size="sm" />{" "}
          <span>{t("drawer.seeAll")}</span>
        </button>
      )}
    </div>
  )
}
